import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useUpdateCareProviderMutation as useUpdateCareProvideMutationType } from "@/modules/care-provider/components/edit-care-provider/services/__generated__/useUpdateCareProviderMutation.graphql"

const mutation = graphql`
  mutation useUpdateCareProviderMutation($input: Ch_updateCareProviderInput!) {
    ch_updateCareProvider(input: $input) {
      careProvider {
        id
      }
    }
  }
`

export const useUpdateCareProviderMutation = () => {
  return useMutationWithErrorToast<useUpdateCareProvideMutationType>(mutation)
}
